import { render } from "./DashboardHome.vue?vue&type=template&id=24ebd0a6"
import script from "./DashboardHome.vue?vue&type=script&lang=js"
export * from "./DashboardHome.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\metavision-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__